export const bannerData = {
  img: require("@/assets/img/idass/IDaaS-banner.png"),
  title: "IDaaS统一身份管理系统",
  text: "为解决企业客户复杂身份管理诉求，提供的统一身份、" +
    "单点登录、数据同步、集中权限、" +
    "应用管理等服务，",
  link: "Register",
  linkText: "开始免费试用",
}
export const contentData = [
  {
    icon: require("@/assets/img/idass/icon-1-select.svg"),
    title: "统一身份管理",
    text: "集中的账号管理中心，对企业员" +
      "工入职、 离职及职位变动引发的" +
      "IT系统账号信息的进行全生命周" +
      "期管理。",
    bgColor: "#caddfd",
    bgDecorate: "#a3c5fe",
    img: require("@/assets/img/idass/身份管理.png"),
    anchor: 'idaas-data-1',
  },
  {
    icon: require("@/assets/img/idass/icon-2-select.svg"),
    title: "统一身份认证",
    text: "支持手机/微信/飞书/钉钉等" +
      "社交认证快速登录使用",
    bgColor: "#cdf1e4",
    bgDecorate: "#a3e7d0",
    img: require("@/assets/img/idass/身份认证.png"),
    anchor: 'idaas-data-2',
  },
  {
    icon: require("@/assets/img/idass/icon-3-select.svg"),
    title: "单点登录",
    text: "一个账号、一个密码、一个入口、" +
      "一键登录、一健退出所有本地应" +
      "用和SaaS应用",
    bgColor: "#caddfd",
    bgDecorate: "#a3c5fe",
    img: require("@/assets/img/idass/单点登录.png"),
    anchor: 'idaas-data-3',
  },
  {
    icon: require("@/assets/img/idass/icon-4-select.svg"),
    title: "安全审计",
    text: "全面审计用户的访问行为和操作" +
      "轨迹； 可实时展示详细的数据" +
      "报表。",
    bgColor: "#cdf1e4",
    bgDecorate: "#a3e7d0",
    img: require("@/assets/img/idass/安全审计.png"),
    anchor: 'idaas-data-4',
  }
]

export const anchorMenuData = [
  {
    anchor: 'idaas-data-1',
    icon: require("@/assets/img/home/idaas/IDaaS-icon-1.svg"),
    title: '统一身份管理',
    type: 1
  },
  {
    anchor: 'idaas-data-2',
    icon: require("@/assets/img/home/idaas/IDaaS-icon-2.svg"),
    title: '统一身份认证',
    type: 1
  },
  {
    anchor: 'idaas-data-3',
    icon: require("@/assets/img/home/idaas/IDaaS-icon-3.svg"),
    title: '单点登录',
    type: 1
  },
  {
    anchor: 'idaas-data-4',
    icon: require("@/assets/img/home/idaas/IDaaS-icon-4.svg"),
    title: '安全审计',
    type: 1
  }
]
